import AppSearchPlugin from './app-search-plugin'
import AppOptionsPlugin from './app-options-plugin'
import AppConsentPlugin from './app-consent-plugin'

export const getAppPlugins = () => [AppSearchPlugin, AppOptionsPlugin, AppConsentPlugin]
